import React, { useState, useEffect } from 'react';
import { LayoutDashboard, DollarSign, ShoppingCart, Users, Package, BarChart3, FileText, Settings, Search, Bell, User, ChevronRight, TrendingUp, AlertCircle, Sparkles, Zap, Clock, Activity, Menu } from 'lucide-react';

import { useNavigate } from "react-router-dom";
const modules = [
  {
    id: 'accounting',
    url: '/COA/all',
    name: 'Accounting',
    description: 'Complete financial operations and real-time reporting',
    icon: DollarSign,
    gradient: 'from-emerald-400 via-teal-500 to-cyan-600',
    lightGradient: 'from-emerald-50 via-teal-50 to-cyan-50',
    stats: { value: '$2.4M', label: 'Revenue MTD', trend: '+12.5%' },
    notifications: 3,
    status: 'active'
  },
  {
    id: 'pos',
    name: 'Point Of Sales',
     url: '/POS',
    description: 'Multi-channel sales and customer engagement platform',
    icon: ShoppingCart,
    gradient: 'from-blue-400 via-indigo-500 to-purple-600',
    lightGradient: 'from-blue-50 via-indigo-50 to-purple-50',
    stats: { value: '1,847', label: 'Orders Today', trend: '+8.3%' },
    notifications: 12,
    status: 'active'
  },
  
 /** {
    id: 'ecommerce',
    name: 'E-Commerce',
     url: '/E-commerce',
    description: 'Multi-channel sales and customer engagement platform',
    icon: ShoppingCart,
    gradient: 'from-blue-400 via-indigo-500 to-purple-600',
    lightGradient: 'from-blue-50 via-indigo-50 to-purple-50',
    stats: { value: '1,847', label: 'Orders Today', trend: '+8.3%' },
    notifications: 12,
    status: 'active'
  },
  {
    id: 'hr',
    name: 'Human Resources',
    url: '/staff',
    description: 'Workforce management and talent optimization',
    icon: Users,
    gradient: 'from-violet-400 via-purple-500 to-fuchsia-600',
    lightGradient: 'from-violet-50 via-purple-50 to-fuchsia-50',
    stats: { value: '342', label: 'Team Members', trend: '+5.2%' },
    notifications: 5,
    status: 'active'
  },**/
  {
    id: 'hr',
    name: 'Users & Roles Management',
    url: '/staff',
    description: 'Workforce management and talent optimization',
    icon: Users,
    gradient: 'from-violet-400 via-purple-500 to-fuchsia-600',
    lightGradient: 'from-violet-50 via-purple-50 to-fuchsia-50',
    stats: { value: '342', label: 'Team Members', trend: '+5.2%' },
    notifications: 5,
    status: 'active'
  },
  {
    id: 'inventory',
    name: 'CRM',
     url: '/CRM',
    description: 'Smart supply chain and warehouse operations',
    icon: Package,
    gradient: 'from-orange-400 via-red-500 to-pink-600',
    lightGradient: 'from-orange-50 via-red-50 to-pink-50',
    stats: { value: '98.2%', label: 'Stock Accuracy', trend: '-2.1%' },
    notifications: 8,
    status: 'warning'
  },
  {
    id: 'analytics',
    name: 'Analytics',
     url: '/dashboard',
    description: 'AI-powered insights and predictive intelligence',
    icon: BarChart3,
    gradient: 'from-cyan-400 via-sky-500 to-blue-600',
    lightGradient: 'from-cyan-50 via-sky-50 to-blue-50',
    stats: { value: '156', label: 'Reports Generated', trend: '+24.7%' },
    notifications: 2,
    status: 'active'
  },
  {
    id: 'documents',
    name: 'Documents',
     url: '/Documents',
    description: 'Secure document management and collaboration',
    icon: FileText,
    gradient: 'from-slate-400 via-gray-500 to-zinc-600',
    lightGradient: 'from-slate-50 via-gray-50 to-zinc-50',
    stats: { value: '12.4K', label: 'Files Managed', trend: '+15.8%' },
    notifications: 0,
    status: 'active'
  }
];

const quickActions = [
  { icon: Zap, label: 'Quick Invoice', gradient: 'from-yellow-500 to-orange-500' },
  { icon: TrendingUp, label: 'View Reports', gradient: 'from-green-500 to-emerald-500' },
  { icon: Clock, label: 'Timesheets', gradient: 'from-blue-500 to-indigo-500' },
  { icon: Activity, label: 'Live Activity', gradient: 'from-purple-500 to-pink-500' }
];

export default function ERPDashboard() {
  const [searchQuery, setSearchQuery] = useState('');
  const [hoveredModule, setHoveredModule] = useState(null);
  const [time, setTime] = useState(new Date());
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
   const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const filteredModules = modules.filter(module =>
    module.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    module.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalNotifications = modules.reduce((sum, m) => sum + m.notifications, 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 relative ">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:64px_64px]"></div>
        
        {/* Floating Gradient Orbs */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-br from-blue-200/40 to-purple-200/40 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-emerald-200/40 to-cyan-200/40 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] bg-gradient-to-br from-pink-200/30 to-orange-200/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '4s' }}></div>
      </div>

      {/* Mouse Follower */}
      <div 
        className="fixed w-[500px] h-[500px] bg-gradient-to-br from-blue-300/20 to-purple-300/20 rounded-full blur-3xl pointer-events-none transition-all duration-700 ease-out opacity-60"
        style={{
          left: mousePosition.x - 250,
          top: mousePosition.y - 250,
        }}
      ></div>

      <div className="relative z-10">
        {/* Header */}
        <header className="border-b border-slate-200/80 backdrop-blur-xl bg-white/80 sticky top-0 z-50 shadow-sm">
          <div className="max-w-[1600px] mx-auto px-8 py-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl blur-lg opacity-60 group-hover:opacity-100 transition-opacity"></div>
                  <div className="relative w-12 h-12 bg-gradient-to-br from-blue-500 via-purple-600 to-pink-500 rounded-2xl flex items-center justify-center shadow-xl transform group-hover:scale-105 transition-transform">
                    <LayoutDashboard className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div>
                  <h1 className="text-xl font-bold bg-gradient-to-r from-slate-900 via-blue-900 to-purple-900 bg-clip-text text-transparent">
                    Enterprise Command Center
                  </h1>
                  <p className="text-xs text-slate-600 flex items-center gap-2 font-medium">
                    <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse shadow-lg shadow-green-500/50"></span>
                    All systems operational
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4">
                {/* Quick Actions */}
                <div className="hidden xl:flex items-center gap-2">
                  {quickActions.map((action, i) => {
                    const Icon = action.icon;
                    return (
                      <button
                        key={i}
                        className="group relative px-4 py-2.5 rounded-xl bg-white hover:bg-slate-50 border border-slate-200 hover:border-slate-300 transition-all duration-300 shadow-sm hover:shadow-md"
                      >
                        <div className="flex items-center gap-2">
                          <div className={`w-5 h-5 bg-gradient-to-br ${action.gradient} rounded-lg flex items-center justify-center transform group-hover:scale-110 transition-transform`}>
                            <Icon className="w-3 h-3 text-white" />
                          </div>
                          <span className="text-xs text-slate-700 font-semibold">{action.label}</span>
                        </div>
                      </button>
                    );
                  })}
                </div>

                <div className="h-8 w-px bg-slate-200"></div>

                {/* Time */}
                <div className="text-right hidden md:block">
                  <div className="text-sm font-bold text-slate-900">
                    {time.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                  <div className="text-xs text-slate-500 font-medium">
                    {time.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                  </div>
                </div>

                {/* Notifications */}
                <button className="relative p-2.5 hover:bg-slate-100 rounded-xl transition-all duration-300 group">
                  <Bell className="w-5 h-5 text-slate-600 group-hover:text-slate-900 transition-colors" />
                  {totalNotifications > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-br from-red-500 to-pink-600 rounded-full text-[10px] font-bold text-white flex items-center justify-center animate-pulse shadow-lg">
                      {totalNotifications}
                    </span>
                  )}
                </button>

                {/* Settings */}
                <button className="p-2.5 hover:bg-slate-100 rounded-xl transition-all duration-300 group">
                  <Settings className="w-5 h-5 text-slate-600 group-hover:text-slate-900 group-hover:rotate-90 transition-all duration-500" />
                </button>

                {/* Menu (Mobile) */}
                <button className="lg:hidden p-2.5 hover:bg-slate-100 rounded-xl transition-all">
                  <Menu className="w-5 h-5 text-slate-600" />
                </button>

                {/* Profile */}
                <div className="relative group cursor-pointer">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full blur-md opacity-0 group-hover:opacity-60 transition-opacity"></div>
                  <div className="relative w-10 h-10 bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 rounded-full flex items-center justify-center ring-2 ring-slate-200 group-hover:ring-4 group-hover:ring-blue-200 transition-all shadow-lg">
                    <span className="text-sm font-bold text-white">JD</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="max-w-[1600px] mx-auto px-8 py-12">
          {/* Welcome Section */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-xl flex items-center justify-center shadow-lg animate-pulse">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <h2 className="text-5xl font-bold bg-gradient-to-r from-slate-900 via-blue-900 to-purple-900 bg-clip-text text-transparent">
                Command Center
              </h2>
            </div>
            <p className="text-slate-600 text-lg font-medium">Orchestrate your entire business operations from one unified platform</p>
          </div>

          {/* Search Bar */}
          <div className="mb-12">
            <div className="relative max-w-2xl group">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative">
                <Search className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                <input
                  type="text"
                  placeholder="Search modules, features, or commands..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-14 pr-20 py-4 bg-white rounded-2xl border-2 border-slate-200 focus:border-blue-500 focus:outline-none focus:ring-4 focus:ring-blue-500/10 transition-all text-slate-900 placeholder:text-slate-400 shadow-sm hover:shadow-md font-medium"
                />
                <div className="absolute right-5 top-1/2 -translate-y-1/2 px-2.5 py-1 bg-slate-100 rounded-lg text-xs text-slate-600 font-bold border border-slate-200">
                  ⌘K
                </div>
              </div>
            </div>
          </div>

          {/* Modules Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredModules.map((module) => {
              const Icon = module.icon;
              const isHovered = hoveredModule === module.id;
              
              return (
                <button
                  key={module.id}
                  onMouseEnter={() => setHoveredModule(module.id)}
                  onMouseLeave={() => setHoveredModule(null)}
                  onClick={()=>navigate(`${module.url}`)}
                  className="group relative text-left transform hover:scale-[1.02] transition-all duration-500"
                >
                  {/* Glow Effect */}
                  <div className={`absolute -inset-1 bg-gradient-to-br ${module.gradient} rounded-3xl blur-xl opacity-0 group-hover:opacity-40 transition-all duration-500`}></div>
                  
                  {/* Card */}
                  <div className="relative h-full bg-white rounded-3xl border-2 border-slate-200 group-hover:border-slate-300 transition-all duration-500 overflow-hidden shadow-lg group-hover:shadow-2xl">
                    {/* Background Gradient */}
                    <div className={`absolute inset-0 bg-gradient-to-br ${module.lightGradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
                    
                    {/* Shimmer Effect */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
                    </div>

                    <div className="relative p-8">
                      {/* Header */}
                      <div className="flex items-start justify-between mb-6">
                        <div className="relative">
                          <div className={`absolute inset-0 bg-gradient-to-br ${module.gradient} rounded-2xl blur-lg opacity-50 group-hover:opacity-100 transition-opacity`}></div>
                          <div className={`relative w-16 h-16 bg-gradient-to-br ${module.gradient} rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-xl`}>
                            <Icon className="w-8 h-8 text-white" />
                          </div>
                        </div>

                        {/* Notifications Badge */}
                        {module.notifications > 0 && (
                          <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 backdrop-blur-sm rounded-full border-2 border-red-200 shadow-sm">
                            <AlertCircle className="w-3.5 h-3.5 text-red-600" />
                            <span className="text-xs font-bold text-red-600">{module.notifications}</span>
                          </div>
                        )}
                      </div>

                      {/* Content */}
                      <div className="mb-6">
                        <h3 className="text-2xl font-bold text-slate-900 mb-2 group-hover:bg-gradient-to-r group-hover:from-slate-900 group-hover:to-blue-900 group-hover:bg-clip-text group-hover:text-transparent transition-all duration-300">
                          {module.name}
                        </h3>
                        <p className="text-slate-600 text-sm leading-relaxed font-medium">
                          {module.description}
                        </p>
                      </div>

                      {/* Stats */}
                      <div className="flex items-end justify-between pt-6 border-t-2 border-slate-100 group-hover:border-slate-200">
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-xs text-slate-500 uppercase tracking-wider font-bold">{module.stats.label}</span>
                            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${module.stats.trend.startsWith('+') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                              {module.stats.trend}
                            </span>
                          </div>
                          <p className="text-3xl font-bold text-slate-900">{module.stats.value}</p>
                        </div>

                        <div className={`p-3 rounded-xl bg-slate-50 group-hover:bg-slate-100 transition-all duration-300 ${isHovered ? 'translate-x-0' : 'translate-x-2'}`}>
                          <ChevronRight className={`w-5 h-5 text-slate-400 group-hover:text-slate-900 transition-all duration-300 ${isHovered ? 'translate-x-1' : ''}`} />
                        </div>
                      </div>
                    </div>

                    {/* Bottom Accent */}
                    <div className={`absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r ${module.gradient} transform origin-left transition-transform duration-500 ${isHovered ? 'scale-x-100' : 'scale-x-0'}`}></div>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Empty State */}
          {filteredModules.length === 0 && (
            <div className="text-center py-32">
              <div className="relative w-24 h-24 mx-auto mb-6">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full blur-2xl opacity-30"></div>
                <div className="relative w-full h-full bg-white rounded-full flex items-center justify-center backdrop-blur-xl border-2 border-slate-200 shadow-lg">
                  <Search className="w-12 h-12 text-slate-400" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3">No modules found</h3>
              <p className="text-slate-600 font-medium">Try adjusting your search query or explore available modules</p>
            </div>
          )}
        </main>

        {/* Footer */}
        <footer className="max-w-[1600px] mx-auto px-8 py-10 mt-20">
          <div className="flex items-center justify-between text-sm border-t-2 border-slate-200 pt-10">
            <p className="text-slate-600 font-medium">© 2024 Enterprise Suite. Powered by Innovation.</p>
            <div className="flex items-center gap-8">
              <a href="#" className="text-slate-600 hover:text-slate-900 font-medium transition-colors">Support</a>
              <a href="#" className="text-slate-600 hover:text-slate-900 font-medium transition-colors">Documentation</a>
              <a href="#" className="text-slate-600 hover:text-slate-900 font-medium transition-colors">API</a>
              <a href="#" className="text-slate-600 hover:text-slate-900 font-medium transition-colors">Status</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}